import * as React from 'react';
import {
  AutocompletePicker,
  AutocompletePickerProps,
} from 'app/components/BasicPickers/AutocompletePicker';
import { Entity } from 'types/common';

export interface NamePickerPrpps
  extends Omit<AutocompletePickerProps<Entity<string>>, 'loadData'> {
  names: Entity<string>[] | undefined;
}
export function NamePicker(props: NamePickerPrpps) {
  return (
    <AutocompletePicker
      loadData={() =>
        Promise.resolve(props.names !== undefined ? props.names : [])
      }
      variant="filled"
      fullWidth
      {...props}
    />
  );
}
